module.exports = __webpack_public_path__ + "static/media/calendar-dark-blue.2d2c78ac.svg";